const routes = [
  {
    path: '/badwords',
    name: 'badwords-list',
    component: () => import(/* webpackChunkName: "page/badwords/list" */'@/views/pages/badwords/List'),
    meta: {
      permissions: 'badwords_read'
    }
  },
  {
    path: '/badwords/new',
    name: 'badwords-new',
    component: () => import(/* webpackChunkName: "page/badwords/new" */'@/views/pages/badwords/New'),
    meta: {
      permissions: 'badwords_write'
    }
  },
  {
    path: '/badwords/:id',
    name: 'badwords-single',
    component: () => import(/* webpackChunkName: "page/badwords/single" */'@/views/pages/badwords/Single'),
    meta: {
      permissions: 'badwords_read'
    }
  },
  {
    path: '/badwords/:id/edit',
    name: 'badwords-edit',
    component: () => import(/* webpackChunkName: "page/badwords/edit" */'@/views/pages/badwords/Edit'),
    meta: {
      permissions: 'badwords_write'
    }
  }
]

export default routes
